"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasInvalidToken = exports.hasUnknownToken = exports.hasTokenType = exports.getTokens = void 0;
const types_1 = require("./types");
// E.g. { type: 'VARIABLE', value: 'n1' }
function makeToken(type, value) {
    return { type, value };
}
// Returns a token for the first matcher to match the text.
// Matchers look like this: [/^[^$]+/, TokenType.STRING]
// If no matchers match the text, a token with type UNKNOWN is returned.
function matchToken(text, matchers) {
    for (const matcher of matchers) {
        const match = matcher[0].exec(text);
        if (match !== null) {
            return makeToken(matcher[1], match[0]);
        }
    }
    return makeToken(types_1.TokenType.UNKNOWN, text);
}
// Returns an array of tokens (e.g. { type: 'VARIABLE', value: 'n1' } )
// that make up the specified string.
// The available token value-types are specified by an array of token matchers.
function getTokens(text, matchers) {
    var _a;
    let startFromIndex = 0;
    const tokens = [];
    while (startFromIndex < (text !== null && text !== void 0 ? text : '').length) {
        const token = matchToken(text.slice(startFromIndex), matchers);
        tokens.push(token);
        startFromIndex += ((_a = token.value) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }
    return tokens;
}
exports.getTokens = getTokens;
// Token type checkers
// Returns true if at least one token in an array
// matches the specified type.
function hasTokenType(tokens, type) {
    return tokens.some((t) => t.type === type);
}
exports.hasTokenType = hasTokenType;
// Returns true if at least one token in an array
// matches the UNKNOWN type.
function hasUnknownToken(tokens) {
    return hasTokenType(tokens, types_1.TokenType.UNKNOWN);
}
exports.hasUnknownToken = hasUnknownToken;
// Returns true if at least one token in an array
// matches the INVALID type.
function hasInvalidToken(tokens) {
    return hasTokenType(tokens, types_1.TokenType.INVALID);
}
exports.hasInvalidToken = hasInvalidToken;
